(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('MdeOfficeService', MdeOfficeService);

    MdeOfficeService.$inject = ['$resource','$q', 'halClient', '$http'];

    function MdeOfficeService($resource, $q, halClient, $http) {
        var baseUrl = 'api/mde-office';
        var service = {};

        service.findAll = findAll;

        function findAll() {
            var deferred = $q.defer();
            var url = baseUrl;
            $http.get(url).success(function (data) {
                deferred.resolve(data);
            }).error(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        }

        return service;
    }
})();
